import SectionLabel from "../components/shared/SectionLabel";
import ProjectCard from "../components/shared/ProjectCard";
import { personalProjects, contractProjects } from "../data/projects";

const Projects = () => {
  return (
    <div className="fade-up">
      <SectionLabel>projects</SectionLabel>
      <h1 className="text-3xl lg:text-4xl font-bold">What I've built.</h1>

      <div className="mt-14">
        <h2 className="text-sm font-mono text-muted uppercase tracking-wide">
          Personal Projects
        </h2>
        <div className="mt-4">
          {personalProjects.map((project, i) => (
            <ProjectCard key={project.slug} project={project} index={i} />
          ))}
        </div>
      </div>

      <div className="mt-14">
        <h2 className="text-sm font-mono text-muted uppercase tracking-wide">
          Contract Work
        </h2>
        <div className="mt-4">
          {contractProjects.map((project, i) => (
            <ProjectCard key={project.slug} project={project} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
